import { Component } from 'react';
import Banner from '../components/common/Banner';

export default class Contact extends Component {
  render() {
    return (
      <>
        {/* Page Title */}
        <Banner title={"Join Varenya Matrimonial today"} desc={"Register Now"} img={"images/bg/bg_3.jpg"} />

        {/* contact info section */}
        <section className="section contact-info ">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-sm-12 col-md-12">
                <div className="section-title text-center">
                  <h2 className="text-md mb-2">
                    Ready to join? <br />Our team is here to assist!
                  </h2>

                  <div className="divider mx-auto my-4"></div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-md-6">
                <div className="contact-block mb-4 mb-lg-0">
                  <i className="icofont-live-support" style={{ color: "#7d1919" }}></i>
                  <h5>Call Us</h5>
                  +91 63603 34247<br />
                  +91 87621 59777
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-md-6">
                <div className="contact-block mb-4 mb-lg-0">
                  <i className="icofont-support-faq" style={{ color: "#7d1919" }}></i>
                  <h5>Email Us</h5>
                  varenyamatrimonial@gmail.com
                  varenyastudios@gmail.com
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-md-6">
                <div className="contact-block mb-4 mb-lg-0">
                  <i className="icofont-location-pin" style={{ color: "#7d1919" }}></i>
                  <h5>Location</h5>
                  # 755, I Block, Ramakrishna Nagar, Mysuru, Karnataka, India
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
